export default __webpack_public_path__ + "static/media/lumoz.dd7f66e6.png";